import React from 'react';

const BlogPost = ({ post, onBack }) => {
    if (!post) {
        return (
            <div className="vg-page page-service" id="blog-detail">
                <div className="container">
                    <div className="text-center">
                        <h1>Blog post not found</h1>
                        <button className="btn-primary" onClick={onBack}>
                            ← Back to Blog
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    const renderSection = (section, index) => {
        switch (section.type) {
            case 'heading':
                const HeadingTag = `h${section.level || 2}`;
                return (
                    <HeadingTag key={index} className={`blog-heading-${section.level || 2}`}>
                        {section.content}
                    </HeadingTag>
                );
            
            case 'paragraph':
                return (
                    <p key={index} className="blog-paragraph">
                        {section.content}
                    </p>
                );
            
            case 'list':
                const ListTag = section.ordered ? 'ol' : 'ul';
                return (
                    <ListTag key={index} className="blog-list">
                        {section.items.map((item, itemIndex) => (
                            <li key={itemIndex} className="blog-list-item">
                                {typeof item === 'string' ? item : renderSection(item, itemIndex)}
                            </li>
                        ))}
                    </ListTag>
                );
            
            case 'code':
                return (
                    <pre key={index} className="blog-code-block">
                        <code>{section.content}</code>
                    </pre>
                );
            
            case 'inline-code':
                return (
                    <code key={index} className="blog-inline-code">
                        {section.content}
                    </code>
                );
            
            case 'table':
                return (
                    <table key={index} className="blog-table">
                        <thead>
                            <tr>
                                {section.headers.map((header, headerIndex) => (
                                    <th key={headerIndex}>{header}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {section.rows.map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                    {row.map((cell, cellIndex) => (
                                        <td key={cellIndex}>{cell}</td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                );
            
            case 'blockquote':
                return (
                    <blockquote key={index} className="blog-blockquote">
                        {section.content}
                    </blockquote>
                );
            
            case 'button':
                return (
                    <button 
                        key={index} 
                        className={`blog-button ${section.variant || 'primary'}`}
                        onClick={section.onClick}
                    >
                        {section.content}
                    </button>
                );
            
            case 'preview':
                return (
                    <div key={index} className="blog-preview">
                        {section.component}
                    </div>
                );
            
            case 'divider':
                return <hr key={index} className="blog-divider" />;
            
            case 'image':
                return (
                    <div key={index} className="blog-image-container">
                        <img 
                            src={section.src} 
                            alt={section.alt || ''} 
                            className="blog-image"
                        />
                        {section.caption && (
                            <p className="blog-image-caption">{section.caption}</p>
                        )}
                    </div>
                );
            
            default:
                return null;
        }
    };

    return (
        <div className="vg-page page-service" id="blog-detail">
            <div className="container">
                {/* Back Button */}
                <div className="blog-navigation">
                    <button className="back-btn" onClick={onBack}>
                        ← Back to Blog
                    </button>
                </div>

                {/* Blog Header */}
                <article className="blog-post-container">
                    <header className="blog-post-header">
                        <div className="blog-post-meta">
                            <span className="blog-date">{post.date}</span>
                            <span className="blog-read-time">{post.readTime}</span>
                        </div>
                        
                        <h1 className="blog-post-title">{post.title}</h1>
                        
                        <div className="blog-post-tags">
                            {post.tags.map(tag => (
                                <span key={tag} className="blog-tag">{tag}</span>
                            ))}
                        </div>
                    </header>

                    {/* Blog Content */}
                    <div className="blog-post-content">
                        {post.sections ? (
                            post.sections.map((section, index) => renderSection(section, index))
                        ) : (
                            <div>
                                <p className="blog-excerpt">{post.excerpt}</p>
                                <p>This blog post doesn't have structured content yet. Please add sections to display the full content.</p>
                            </div>
                        )}
                    </div>

                    {/* Blog Footer */}
                    <footer className="blog-post-footer">
                        <div className="blog-post-actions">
                            <button className="share-btn">
                                Share Article
                            </button>
                            <button className="bookmark-btn">
                                Bookmark
                            </button>
                        </div>
                        
                        <div className="blog-post-navigation">
                            <button className="nav-btn prev-btn" disabled>
                                ← Previous Post
                            </button>
                            <button className="nav-btn next-btn" disabled>
                                Next Post →
                            </button>
                        </div>
                    </footer>
                </article>

                {/* Related Posts Section */}
                <section className="related-posts">
                    <h3>Related Articles</h3>
                    <p className="related-posts-placeholder">
                        Related posts would be displayed here based on tags and categories.
                    </p>
                </section>
            </div>
        </div>
    );
};

export default BlogPost;